var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Astronaut--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.33,109.11a5.29,5.29,0,0,1,2.8.41c.08,0,.67.31.29.12a7,7,0,0,1,.7.4,7.85,7.85,0,0,1,.66.47c.51.38-.18-.25.25.22a6.08,6.08,0,0,1,1.4,2.11,5.54,5.54,0,0,1,.31,2.46c0,.23,0,.45-.07.68.06-.45-.11.4-.13.49s-.14.43-.22.64-.29.63-.1.27a6.66,6.66,0,0,1-.86,1.3c.28-.32-.14.14-.21.2s-.44.38-.66.57.19-.07-.24.17l-.57.33a8.33,8.33,0,0,1-.81.36c.39-.14-.26.08-.28.08-.25.07-.5.12-.75.17-.09,0-.81.08-.39.06a8.78,8.78,0,0,1-1.54-.07,2.3,2.3,0,0,0-2.38,2.2,2.33,2.33,0,0,0,2.19,2.38,10.33,10.33,0,0,0,7.84-18.24,10.3,10.3,0,0,0-7-2.36,2.37,2.37,0,0,0-2.39,2.2,2.31,2.31,0,0,0,2.2,2.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.53,
    y: 79.35,
    width: 126.28,
    height: 166.67,
    rx: 19.38,
    transform: "translate(-1.98 3.06) rotate(-0.7)",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.17,147.26a4.9,4.9,0,0,1,0-.51l0-1.51c0-1.35,0-3.3-.05-5.8,0-5.06,0-12.35-.08-21.34,0-4.5,0-9.44,0-14.73a7.69,7.69,0,0,1,.92-4,7.45,7.45,0,0,1,3-3,7.19,7.19,0,0,1,2.08-.7,11.59,11.59,0,0,1,2.19-.12h4.41l38.75,0,38.76,0h4.41a11.65,11.65,0,0,1,2.2.12,7.13,7.13,0,0,1,2.07.7,7.38,7.38,0,0,1,3,3,7.63,7.63,0,0,1,.92,4c0,5.29,0,10.23,0,14.73,0,9-.07,16.28-.09,21.34,0,2.5,0,4.45-.05,5.8l0,1.51c0,.34,0,.51,0,.51a4.9,4.9,0,0,1,0-.51c0-.36,0-.86,0-1.51,0-1.35,0-3.3-.05-5.8,0-5.06-.05-12.34-.08-21.34,0-4.5,0-9.44,0-14.73a7.27,7.27,0,0,0-.88-3.78,7,7,0,0,0-2.87-2.76,6.63,6.63,0,0,0-1.94-.65,9.88,9.88,0,0,0-2.12-.11h-4.41l-38.76,0-38.75,0h-4.41a10.48,10.48,0,0,0-2.11.1,6.91,6.91,0,0,0-2,.66,7,7,0,0,0-2.86,2.76,7.27,7.27,0,0,0-.88,3.78c0,5.29,0,10.23,0,14.73,0,9-.07,16.28-.09,21.34,0,2.5,0,4.45,0,5.8l0,1.51C195.19,147.09,195.17,147.26,195.17,147.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.22,240.81c.29-.32-5-60.89-5-60.89l-12.92-3.36,4.18,57.76,7.08,10.33A15,15,0,0,0,306.22,240.81Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.82,
    cy: 106.84,
    r: 2.33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.82,
    cy: 114.87,
    r: 2.33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.69,121.55s-13,3.71-16,5.48-30.68,29.07-31.66,29.86c-.7.55-10.82-10.62-16.68-18.07l-7.56-4.23L120.43,148l.38,8.92c6.43,10.21,19.37,29.9,25.4,34.75,8,6.48,18.82,6.87,27.35,3.31,5.05-2.1,26.17-18.72,26.17-18.72l11.18-4.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,158.1a23.47,23.47,0,0,1,1.24,3l2.76,7.35,2.83,7.31a25,25,0,0,1,1.13,3,17,17,0,0,1-1.47-2.9c-.83-1.84-1.89-4.41-3-7.28s-2-5.49-2.63-7.4A18.58,18.58,0,0,1,185,158.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.35,184.26a7.73,7.73,0,0,1-1.13-1.09c-.71-.72-1.68-1.81-2.83-3.21a69,69,0,0,1-13-24.89c-.49-1.74-.83-3.17-1-4.16a8.18,8.18,0,0,1-.24-1.55,9.64,9.64,0,0,1,.44,1.51c.25,1,.64,2.38,1.17,4.09a78.66,78.66,0,0,0,5.32,13,77.79,77.79,0,0,0,7.6,11.79c1.1,1.42,2,2.55,2.69,3.31A10.71,10.71,0,0,1,189.35,184.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,165.34a17.84,17.84,0,0,1,.11-4.31,18.32,18.32,0,0,1,.64-4.28,18.28,18.28,0,0,1-.12,4.32A18,18,0,0,1,161,165.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.48,155.56c-.66.57,2.36,20.83,17.48,34.78l3.56-2.55s-17.08-16-18-35.21Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.39,138.82c.09.12-5.34,4.26-12.13,9.25s-12.37,9-12.45,8.84,5.35-4.26,12.14-9.26S145.31,138.71,145.39,138.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.67,165.74a4.5,4.5,0,0,1,.68-.8l2-2.08c1.73-1.75,4.14-4.16,6.89-6.86l0,.35L135.16,155l-1.51-1.86.35,0c-3,2.1-5.68,3.94-7.61,5.24l-2.28,1.5a4.36,4.36,0,0,1-.86.5,3.65,3.65,0,0,1,.76-.65l2.19-1.63c1.87-1.37,4.5-3.26,7.5-5.38l.2-.14.15.18,1.51,1.86,1.07,1.31.15.18-.17.17c-2.75,2.69-5.22,5-7,6.74l-2.12,2A4.12,4.12,0,0,1,126.67,165.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.72 154.96 143.55 137.79 137.83 134.59 120.43 148 120.72 154.96",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.41,114.13c-.46-.57-.93-1.13-1.42-1.67a10.66,10.66,0,0,0-1.62,2.17,32.71,32.71,0,0,0-3.37,7.19s-6.08-9.54-7.23-11.72a60.38,60.38,0,0,0-3.92-6.55,19.42,19.42,0,0,0-8.54,1c2.6,4.22,7.55,11.56,6.53,12.57-.84.83-5.69-6.3-10-10.84l-.53.35a18.16,18.16,0,0,0-4.23,4.34c3,3.39,6.52,7.32,6.41,8.13s-4-2.69-8-5.56a27.39,27.39,0,0,0-1.76,4.18c-.29.88-.53,1.78-.75,2.69,3.89,3.22,9.63,6.13,6.85,6-1.7-.07-4.77-1.57-7.52-2.7-.32,1.89-.55,3.8-.75,5.71,3.38,2.08,7.21,3.2,8.51,5.06,1.43,2,4.89,8.6,9.29,11s6.07,2.55,6.07,2.55l17.14-11.84s1.27-7.5,1.61-11.5A27.65,27.65,0,0,1,140.9,118C139,117.48,137.66,115.7,136.41,114.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.49,113.49c-3.54-2.59-7.08-4.77-7.83-3.21-1.58,3.28,0,4,3.15,7.94A15.2,15.2,0,0,0,98,120.36c.22-.91.46-1.81.75-2.69A27.39,27.39,0,0,1,100.49,113.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.85,103.55c-2.8-4-6.58-7.8-9.82-5.58,0,0-1.69,1.42.46,5.17.23.39.51.86.82,1.36A19.42,19.42,0,0,1,118.85,103.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.77,123.14c-.84,2.71.28,3.17,3.86,5.65q.45.32.93.6c.2-1.91.43-3.82.75-5.71C94.59,122.56,92.19,121.79,91.77,123.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.9,118c.75-2.2,1.29-4.06.49-5.58-1.22-2.32-4-2.4-6.4.06.49.54,1,1.1,1.42,1.67C137.66,115.7,139,117.48,140.9,118Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.28,106.58l.53-.35a14.29,14.29,0,0,0-4.3-3.42c-4.6-1.76-5.77,1.3-4.55,3.28a60.94,60.94,0,0,0,4.09,4.83A18.16,18.16,0,0,1,106.28,106.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.66,137.49s-.19-.2-.4-.66a7.57,7.57,0,0,1-.6-2,8.66,8.66,0,0,1,.12-3.13,8.22,8.22,0,0,1,1.71-3.45,8.51,8.51,0,0,1,4.93-2.91l-.17.19a26.72,26.72,0,0,1,.54-4,23.92,23.92,0,0,1-.12,4v.16l-.16,0a8.56,8.56,0,0,0-4.61,2.84,8.33,8.33,0,0,0-1.86,6.2A17.77,17.77,0,0,0,123.66,137.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.15,118.3c0,.09-1.05.34-2.66,1a20.24,20.24,0,0,0-5.69,3.7,19.87,19.87,0,0,0-4.09,5.42c-.8,1.56-1.11,2.62-1.2,2.59s0-.28.14-.76a12.15,12.15,0,0,1,.73-2,17.83,17.83,0,0,1,10-9.3,12.88,12.88,0,0,1,2-.59A2.48,2.48,0,0,1,120.15,118.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.15,90.06c-.15,0-.26-4.81-.26-10.75s.11-10.76.26-10.76.26,4.82.26,10.76S279.29,90.06,279.15,90.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.89,80.21s-2.64-44.63,37.75-44.63c42.05,0,40,46.55,40,50.16,0,0,3.05,34-37.5,34.72C202.58,121.25,204.89,80.21,204.89,80.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.76,78.81S204.19,45.55,243,45.54c40.34,0,36.77,34.76,36.77,37.57,0,0,1.55,25.79-36,26.54S207.76,78.81,207.76,78.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.78 118.31 274.31 109.26 215.28 109.66 211.66 120.47 205.14 124.43 245.89 130.96 287.28 124.56 279.78 118.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.09,
    y: 58.23,
    width: 12.49,
    height: 34.05,
    rx: 6.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.72,76.58a1,1,0,0,1-.05-.3c0-.23,0-.53-.07-.9-.09-.79-.09-2-.31-3.44-.09-.75-.2-1.57-.31-2.48s-.36-1.87-.56-2.91-.54-2.13-.84-3.3L277,61.49c-.1-.3-.21-.61-.31-.92s-.25-.6-.38-.91a32.12,32.12,0,0,0-11.37-14.57,39.34,39.34,0,0,0-21.59-6.79c-.45,0-.91,0-1.32,0h0a24.9,24.9,0,0,0-5.84.58,38.19,38.19,0,0,0-5.53,1.54,36.37,36.37,0,0,0-9.53,5.06,32.05,32.05,0,0,0-6.83,7,33,33,0,0,0-4,7.53,43.23,43.23,0,0,0-2.43,12.07c-.13,1.45-.1,2.59-.12,3.36q0,.54,0,.87a1.71,1.71,0,0,1,0,.3,1.16,1.16,0,0,1,0-.3q0-.33,0-.87c0-.77-.07-1.91,0-3.37a41.72,41.72,0,0,1,2.29-12.19,32.65,32.65,0,0,1,4-7.64,32,32,0,0,1,6.89-7.1A36.91,36.91,0,0,1,230.44,40a39.18,39.18,0,0,1,5.6-1.57,25.66,25.66,0,0,1,6-.59h0c.44,0,.89,0,1.36,0a39.69,39.69,0,0,1,21.86,6.92,31.17,31.17,0,0,1,7.21,7.09,32.89,32.89,0,0,1,4.22,7.73l.38.93.3.92c.2.61.39,1.21.57,1.79.3,1.17.59,2.28.82,3.33s.35,2,.51,2.94.19,1.74.27,2.49c.19,1.49.16,2.67.21,3.45,0,.38,0,.67,0,.9A1.43,1.43,0,0,1,279.72,76.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.64,61.06c-4.39,7.41-5.09,16.62-3.25,25,9,1,18.18-3.45,24-10.44s8.39-18,8.32-27.11C228.2,48.49,219,53.65,214.64,61.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.22,49.27C258.75,60,255.91,80,255.91,80h7c3-17.07-2.75-29.09-2.75-29.09h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.59,75.26c.55,0,.59,7.21-1.13,11.78H269c.63,0,2.32-7,1.59-11.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.19,68a34.43,34.43,0,0,1-6,.26,34.5,34.5,0,0,1-6-.26,35.71,35.71,0,0,1,6-.26A35.64,35.64,0,0,1,293.19,68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.71,75.26a2.38,2.38,0,1,1-2.38-2.38A2.38,2.38,0,0,1,289.71,75.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.71,83.7a2.38,2.38,0,1,1-2.38-2.38A2.37,2.37,0,0,1,289.71,83.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.97,
    y: 58.23,
    width: 12.49,
    height: 34.05,
    rx: 6.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.07,68a34.59,34.59,0,0,1-6,.26,34.43,34.43,0,0,1-6-.26,35.64,35.64,0,0,1,6-.26A35.81,35.81,0,0,1,206.07,68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,75.26a2.38,2.38,0,1,1-2.37-2.38A2.38,2.38,0,0,1,202.58,75.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,83.7a2.38,2.38,0,1,1-2.37-2.38A2.37,2.37,0,0,1,202.58,83.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.55,109.66a2.76,2.76,0,0,1-.52.37c-.36.23-.88.57-1.57,1-1.37.82-3.39,1.94-6,3.16a57.15,57.15,0,0,1-9.42,3.48,45.3,45.3,0,0,1-12.19,1.59,56.44,56.44,0,0,1-21.72-4.73,51.33,51.33,0,0,1-6-3.11c-.7-.4-1.2-.76-1.55-1a2.49,2.49,0,0,1-.52-.38,3.71,3.71,0,0,1,.57.29c.37.2.89.53,1.6.91a62.64,62.64,0,0,0,6.05,2.94,58,58,0,0,0,21.58,4.54A45.39,45.39,0,0,0,257,117.17a59.2,59.2,0,0,0,9.38-3.35c2.6-1.16,4.64-2.23,6-3l1.61-.88A3.26,3.26,0,0,1,274.55,109.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.83,118.39a4.09,4.09,0,0,1-.55.52c-.37.32-.92.79-1.65,1.38a62.93,62.93,0,0,1-6.43,4.64,36.53,36.53,0,0,1-10.86,4.51A59.27,59.27,0,0,1,246,131a60.23,60.23,0,0,1-7.46-.47,46.7,46.7,0,0,1-6.82-1.42,57.78,57.78,0,0,1-10.93-4.35,65.68,65.68,0,0,1-6.8-4.06c-.79-.52-1.36-1-1.76-1.25a3.28,3.28,0,0,1-.59-.47,5,5,0,0,1,.65.39c.41.26,1,.67,1.81,1.16a77.29,77.29,0,0,0,6.86,3.91,60.22,60.22,0,0,0,10.89,4.21,50.16,50.16,0,0,0,6.76,1.38,61,61,0,0,0,7.39.45,59.94,59.94,0,0,0,14.21-1.5A36.64,36.64,0,0,0,271,124.61a71.72,71.72,0,0,0,6.51-4.48l1.71-1.3A4.94,4.94,0,0,1,279.83,118.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216,111.06a36.51,36.51,0,0,0,56.77-.34,54.27,54.27,0,0,1-56,.67"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M363.12,259.82a39.34,39.34,0,0,1-5.74-2.17c-1.36-.57-2.72-1.11-4.1-1.62-1,2.59-2.24,5.76.33,7.09,3.49,1.81,5.77,2.53,10.63-.2a19.59,19.59,0,0,0,4-3A11,11,0,0,1,363.12,259.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.37,254.69q-4.08-1.29-8.25-2.19c.15,1.45.26,2.51.32,2.9.33,2.14,1.45,5.35,4.24,5.48S349.54,258.79,349.37,254.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.42 235.51 192.8 176.04 203.17 124.98 210.45 124.98 277.81 118.86 299.61 127.47 298.44 179.76 299.52 225.38 251.51 242.64 201.42 235.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.44,221.88s0-.07-.06-.23-.08-.41-.13-.68c-.11-.65-.26-1.53-.44-2.64-.38-2.34-.9-5.64-1.55-9.71-1.26-8.24-3-19.56-4.91-32.06-1-6.25-2-12.21-2.63-17.68A107.21,107.21,0,0,1,189,144.3a67.06,67.06,0,0,1,.86-9.8c.16-1.15.39-2,.51-2.63l.15-.68a1,1,0,0,1,.07-.23.87.87,0,0,1,0,.24c0,.19-.06.41-.1.69-.08.6-.28,1.48-.41,2.64a73.24,73.24,0,0,0-.69,9.78,113.43,113.43,0,0,0,.88,14.52c.62,5.45,1.62,11.39,2.66,17.65,1.92,12.52,3.57,23.87,4.77,32.09.57,4.07,1,7.39,1.38,9.73.14,1.12.26,2,.35,2.65,0,.28,0,.51.07.7A.58.58,0,0,1,199.44,221.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.19,218.3A15.63,15.63,0,0,1,268.67,227c-4.52-1-8.34-3.93-12-6.78l3.62-3.64,14.45,2.33,8.22-3.68Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M300,230.32a.81.81,0,0,1-.24.06l-.72.13-2.76.46c-2.39.39-5.87.91-10.17,1.49-8.61,1.17-20.53,2.52-33.75,3.49s-25.21,1.34-33.9,1.43c-4.34.05-7.85,0-10.28,0l-2.79,0-.73,0a.79.79,0,0,1-.25,0,.72.72,0,0,1,.25,0l.73,0,2.79,0c2.43,0,5.94-.07,10.28-.17,8.67-.18,20.66-.62,33.86-1.58s25.13-2.26,33.74-3.34c4.31-.53,7.79-1,10.19-1.32l2.77-.36.73-.08A.7.7,0,0,1,300,230.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.68,189.07c-33.17-.84-73.1.12-103.31,1.27l1.37,8.21,102.07-2.74Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.79,185.4a5.2,5.2,0,0,0,1.93-.52,4.26,4.26,0,0,0,2.21-3.12,14.45,14.45,0,0,0,0-1.77c0-5.07-.05-12.38-.08-21.4,0-2.26,0-4.63,0-7.09a4.07,4.07,0,0,0-3.18-3.92,8.58,8.58,0,0,0-1.92-.1l-17,0-38.88,0a4,4,0,0,0-3.75,2.57,6,6,0,0,0-.28,2.41V165c0,3.25,0,6.44,0,9.57v4.64c0,.76,0,1.55,0,2.27a4.05,4.05,0,0,0,4.31,3.73h12.54l14.78,0,21.41.08,5.82,0,1.51,0,.52,0-.52,0-1.51,0-5.82.05-21.41.08-14.78,0H218.21a4.57,4.57,0,0,1-4-1.95,4.5,4.5,0,0,1-.78-2.22c0-.79,0-1.52,0-2.3v-4.64q0-4.7,0-9.57t0-9.92V152.5a6.51,6.51,0,0,1,.32-2.6,4.55,4.55,0,0,1,4.23-2.9l38.88,0,17,0a8.7,8.7,0,0,1,2,.12,4.49,4.49,0,0,1,3.48,4.32c0,2.47,0,4.84,0,7.1,0,9-.06,16.33-.08,21.4a13.16,13.16,0,0,1-.07,1.8,4.31,4.31,0,0,1-.54,1.5,4.26,4.26,0,0,1-1.79,1.68,4.09,4.09,0,0,1-1.46.42A2.89,2.89,0,0,1,274.79,185.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.43,147.22c.45-7-7.44-11.37-12.09-15.07-2.7-2.15-5-4.21-6.31-7.32-.84-2-1.6-4.6-.7-6.75a6.11,6.11,0,0,1,4-3.33,11.25,11.25,0,0,1,5.76.08,20.83,20.83,0,0,1,6.18,2.2c2.79,1.62,5.31-2.7,2.53-4.32a25,25,0,0,0-6.29-2.45,21.11,21.11,0,0,0-6.7-.83c-5.42.42-10.16,4.13-10.76,9.71-.5,4.7,1.84,9.76,5,13.14,2.61,2.79,5.92,5,8.84,7.29a26.26,26.26,0,0,1,4.32,4c-.27-.34.22.31.21.3l.4.62c.1.18.5,1.05.35.67a5.89,5.89,0,0,1,.31,1.09c-.1-.5,0,0,0,.12a7.3,7.3,0,0,1,0,.81c-.2,3.21,4.8,3.2,5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.7 144.27 218.17 144.27 218.04 155.66 206.26 155.66 205.7 144.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.53,
    cy: 212.87,
    r: 7.44,
    transform: "translate(-63.56 104.63) rotate(-22.39)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.35,
    cy: 212.87,
    r: 7.44,
    transform: "translate(-61.69 114.09) rotate(-22.39)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.68,
    cy: 212.87,
    r: 7.44,
    transform: "translate(-63.36 139.73) rotate(-24.98)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.46,215.57c8.2,11.22,24.67,12.9,33.66,1.45,3.9-5-3.08-12-7-7-4.62,5.89-13.28,7.11-18.07.56-3.73-5.11-12.34-.16-8.57,5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.46,215.57a.71.71,0,0,1-.14-.19l-.38-.59a6,6,0,0,1-.41-1.06,4,4,0,0,1,0-1.55,4.73,4.73,0,0,1,2.61-3.23,5.86,5.86,0,0,1,2.57-.69,5.44,5.44,0,0,1,2.9.74,10.13,10.13,0,0,1,2.3,2.32,14.93,14.93,0,0,0,1.21,1.17,11.16,11.16,0,0,0,1.45,1,10,10,0,0,0,7.31.95,12.7,12.7,0,0,0,6.91-4.45c.24-.27.53-.56.79-.84a8.41,8.41,0,0,1,1-.68,4,4,0,0,1,2.37-.35,5.8,5.8,0,0,1,4.26,7.49,12.55,12.55,0,0,1-2.74,3.68,20.29,20.29,0,0,1-7.27,4.57A19.56,19.56,0,0,1,270.5,225a21.1,21.1,0,0,1-6.63-1.35,21.58,21.58,0,0,1-8.14-5.33,16.33,16.33,0,0,1-1.73-2l-.41-.55a.89.89,0,0,1-.13-.19s.06.05.17.16l.46.52a18.74,18.74,0,0,0,1.79,1.94,21.87,21.87,0,0,0,8.12,5.12,20.75,20.75,0,0,0,6.52,1.27,19.22,19.22,0,0,0,7.49-1.19,19.92,19.92,0,0,0,7.07-4.48c.94-1.1,2.13-2.13,2.61-3.5a5.3,5.3,0,0,0-3.85-6.8,3.51,3.51,0,0,0-2,.29,6.65,6.65,0,0,0-.86.61c-.25.27-.5.5-.74.78a13.14,13.14,0,0,1-7.2,4.6,10.42,10.42,0,0,1-7.64-1,13.17,13.17,0,0,1-1.5-1c-.42-.43-.88-.79-1.24-1.24a10.34,10.34,0,0,0-2.19-2.27,5.17,5.17,0,0,0-2.7-.72,5.72,5.72,0,0,0-2.45.62,4.57,4.57,0,0,0-2.55,3,3.92,3.92,0,0,0,0,1.48,6.11,6.11,0,0,0,.35,1.05l.32.6C253.43,215.49,253.47,215.56,253.46,215.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.64,174.2a1.84,1.84,0,1,1-1.83-1.84A1.84,1.84,0,0,1,225.64,174.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.94,174.2a1.84,1.84,0,1,1-1.84-1.84A1.85,1.85,0,0,1,231.94,174.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,174.2a1.84,1.84,0,1,1-1.84-1.84A1.85,1.85,0,0,1,238,174.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.1,174.2a1.84,1.84,0,1,1-1.84-1.84A1.85,1.85,0,0,1,244.1,174.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.39,162.52H224.67a2.21,2.21,0,0,1-2.21-2.21h0a2.21,2.21,0,0,1,2.21-2.21h16.72a2.21,2.21,0,0,1,2.21,2.21h0A2.21,2.21,0,0,1,241.39,162.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,167.18a1.84,1.84,0,1,1-1.84-1.84A1.84,1.84,0,0,1,226,167.18Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.26,167.18a1.84,1.84,0,1,1-1.84-1.84A1.84,1.84,0,0,1,232.26,167.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.34,167.18a1.84,1.84,0,1,1-1.84-1.84A1.84,1.84,0,0,1,238.34,167.18Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.42,167.18a1.84,1.84,0,1,1-1.84-1.84A1.84,1.84,0,0,1,244.42,167.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.32,
    y: 156.67,
    width: 13.5,
    height: 13.5,
    rx: 1.66,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.05,176.56h-12a1.88,1.88,0,0,1-1.88-1.88h0a1.88,1.88,0,0,1,1.88-1.88h12a1.89,1.89,0,0,1,1.89,1.88h0A1.89,1.89,0,0,1,269.05,176.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,185.37s.32,1.16,4,1.76,49.15.5,51.84,0a7.71,7.71,0,0,0,4.13-2.11Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.32,209.48c-2.4-5.64-16.66-29.46-21-36.44s-17-20.46-17-20.46l-12.1-16a41.73,41.73,0,0,0-9.56-9.15h0l-8.49,27.8,3.11,23.61,14.65,7.84,9,14.27,17.79,27.64a17.48,17.48,0,0,0,3.36,1.78L360.72,217S361.62,214.87,359.32,209.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.05,167a4.18,4.18,0,0,1-.24,1,9.07,9.07,0,0,1-.4,1.17,15.88,15.88,0,0,1-.65,1.5,26.74,26.74,0,0,1-2.15,3.68,39.21,39.21,0,0,1-3.28,4.06,47.53,47.53,0,0,1-7.12,6.2c-1,.71-1.81,1.23-2.4,1.58a3.94,3.94,0,0,1-.93.48c0-.07,1.2-.89,3.11-2.35a56.7,56.7,0,0,0,7-6.27,43.82,43.82,0,0,0,3.27-4,31.64,31.64,0,0,0,2.21-3.57C325.54,168.44,326,167,326.05,167Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.62,161c.08,0-.4,1.11-1,2.91s-1.31,4.3-2.07,7.1a70.91,70.91,0,0,1-2.21,7.08c-.35.89-.67,1.6-.91,2.07s-.4.73-.43.71.39-1.11,1-2.9,1.31-4.31,2.06-7.1a72.74,72.74,0,0,1,2.22-7.09,20.26,20.26,0,0,1,.91-2.07A3,3,0,0,1,305.62,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.61,132.42a.73.73,0,0,1,0,.24c0,.19,0,.42-.06.7-.06.66-.14,1.56-.25,2.7s-.17,2.62-.28,4.28-.16,3.57-.25,5.67c-.31,8.4-.48,20-.5,32.86s.08,24.47.17,32.89c0,4.17.08,7.56.1,10,0,1.14,0,2.05,0,2.71,0,.28,0,.52,0,.71a.68.68,0,0,1,0,.24.75.75,0,0,1,0-.24c0-.19,0-.42,0-.71,0-.66-.07-1.56-.11-2.7-.07-2.4-.16-5.8-.27-10-.18-8.41-.33-20-.32-32.89s.25-24.47.65-32.88c.12-2.1.23-4,.33-5.67s.27-3.09.37-4.28.27-2,.35-2.69c0-.28.08-.51.11-.7A.65.65,0,0,1,300.61,132.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.46,213.8c-.63.21-11.21,4.61-12.76,14.83a18.11,18.11,0,0,0,3.84,2L360.72,217a7.74,7.74,0,0,0-.1-3.62S359.19,210.36,348.46,213.8Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.17,231.71s1.94,21.55,2.27,23.69,1.45,5.35,4.24,5.48c3.15.15,4.06-2.59,3.59-7.56s-.5-8.13.44-7.5,4.67,5.22,4.33,7.73-3.93,7.76-.43,9.57,5.77,2.53,10.63-.2a18.17,18.17,0,0,0,6.83-6.45s4-8.35,3.3-11.69c-.27-1.26-8.35-17.44-8.35-17.44l-5.64-9.56s-2.49-4.87-12.2.37C337.92,223.68,338.92,229.11,339.17,231.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.24,183.7a234.36,234.36,0,0,0,19.15-29.9l3.16,3.46a129.67,129.67,0,0,1-19.14,28.14Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.72,202.54s-.37,0-1,.07a17,17,0,0,0-2.78.51,59.84,59.84,0,0,0-8.94,3.35l-.2.09-.12-.17-1.18-1.62-.93-1.28-.13-.18.16-.16a13.21,13.21,0,0,1,4.75-2.86,24.2,24.2,0,0,1,4.3-1.11,27.21,27.21,0,0,1,2.95-.34,4.14,4.14,0,0,1,1.08,0,6.15,6.15,0,0,1-1.06.17c-.69.1-1.68.24-2.9.49a25.72,25.72,0,0,0-4.21,1.21,13,13,0,0,0-4.54,2.79l0-.34.93,1.28c.4.56.8,1.1,1.18,1.62l-.32-.08a49.4,49.4,0,0,1,9.08-3.21,12.77,12.77,0,0,1,2.85-.37,3.83,3.83,0,0,1,.78.06C355.63,202.5,355.72,202.52,355.72,202.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.93,211a43.72,43.72,0,0,0-4.92-.37,20.55,20.55,0,0,0-5.24.77,23.21,23.21,0,0,0-5.91,2.68,23.7,23.7,0,0,0-8,8.54,42.66,42.66,0,0,0-2,4.5,5.68,5.68,0,0,1,.3-1.3,20.91,20.91,0,0,1,1.38-3.38,22.84,22.84,0,0,1,14.12-11.5,19.5,19.5,0,0,1,9-.29A5.46,5.46,0,0,1,359.93,211Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.05,243.57a3,3,0,0,1,.51.75,16.5,16.5,0,0,1,1.05,2.22,14.91,14.91,0,0,1,.91,3.54,11,11,0,0,1-.36,4.49,14.83,14.83,0,0,1-2.05,4,31.26,31.26,0,0,1-2.27,2.84,24.34,24.34,0,0,1-1.72,1.75c-.42.39-.68.59-.7.56s.84-1,2.14-2.55c.65-.79,1.4-1.76,2.15-2.87a14.85,14.85,0,0,0,2-3.88,12.88,12.88,0,0,0-.39-7.75C361.61,244.73,361,243.62,361.05,243.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.88,244.61a2.25,2.25,0,0,1,.33.69,10.76,10.76,0,0,1,.57,2,14.44,14.44,0,0,1,.3,3.07,17.17,17.17,0,0,1-.45,3.76,18,18,0,0,1-1.3,3.55,15.65,15.65,0,0,1-1.66,2.6,10.48,10.48,0,0,1-1.42,1.52c-.37.32-.58.49-.61.46s.73-.8,1.73-2.2a17,17,0,0,0,1.53-2.59,19.58,19.58,0,0,0,1.22-3.47,18.79,18.79,0,0,0,.48-3.64,17,17,0,0,0-.18-3C370.16,245.66,369.79,244.65,369.88,244.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.63,239.44c.12-.07.51.54.39,1.38s-.68,1.3-.77,1.2.16-.6.25-1.28S361.49,239.5,361.63,239.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.78,240.6c.11-.09.53.29.65,1s-.14,1.16-.27,1.12-.14-.5-.24-1S369.66,240.68,369.78,240.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.05,408.81l15.88,37.32-7.46,28.42a11.44,11.44,0,0,0,9.34,12.84,5.81,5.81,0,0,0,1.5.14h0c1.49-.13,5.42-2.72,6.22-3.9,9-13.18,21.54-30.37,19.72-36.38-1-3.43-9.13-44.28-9.13-44.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.49,428.84a2.74,2.74,0,0,1,.32.54c.19.37.45.91.78,1.61a64.63,64.63,0,0,1,2.52,6,29.07,29.07,0,0,1,1.81,9.49,19,19,0,0,1-.85,5.68,44.38,44.38,0,0,1-2.32,5.73c-1.88,3.77-2.94,7.62-4.6,10.94a14.86,14.86,0,0,1-6.81,7.19,9.47,9.47,0,0,1-6.9.4,6.38,6.38,0,0,1-1.67-.87,2.22,2.22,0,0,1-.48-.43,11.3,11.3,0,0,0,2.24,1.06,9.36,9.36,0,0,0,6.59-.57,14.58,14.58,0,0,0,6.45-7c1.58-3.24,2.65-7.15,4.54-10.95a45.73,45.73,0,0,0,2.31-5.65,18.85,18.85,0,0,0,.86-5.5,30,30,0,0,0-1.64-9.35c-.85-2.6-1.73-4.66-2.3-6.09A16.56,16.56,0,0,1,241.49,428.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.26,447.1c-.07.18-2.79-.59-6.25-.89s-6.3-.06-6.32-.25,2.82-.73,6.38-.4S242.33,447,242.26,447.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.94,455.65c-.1.17-2.29-.88-5.2-1.54s-5.37-.71-5.37-.9,2.52-.43,5.53.27S238,455.51,237.94,455.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.6,465c-.13.15-2.1-1.23-4.85-2.34s-5.18-1.55-5.14-1.74,2.56,0,5.42,1.14S236.72,464.87,236.6,465Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,481.67a11.37,11.37,0,0,0,2,.85,9.61,9.61,0,0,0,5.84-.32,16.63,16.63,0,0,0,6.75-5.21c2.07-2.48,4.22-5.33,6.34-8.38a122.34,122.34,0,0,0,9.49-16.41c1-2.18,1.83-4,2.38-5.21a12.36,12.36,0,0,1,.89-1.91,14.14,14.14,0,0,1-.64,2c-.47,1.26-1.18,3.09-2.18,5.3A106.28,106.28,0,0,1,245.56,469c-2.14,3.08-4.3,5.92-6.43,8.41a16.79,16.79,0,0,1-7.08,5.26,9.57,9.57,0,0,1-6.1.13,6,6,0,0,1-1.48-.72C224.17,481.82,224,481.69,224,481.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.66,448.7a17,17,0,0,1-.67-3.07c-.36-1.9-.9-4.51-1.66-7.36s-1.58-5.4-2.2-7.23a17.69,17.69,0,0,1-.94-3,13,13,0,0,1,1.4,2.85,59.4,59.4,0,0,1,3.89,14.68A11.88,11.88,0,0,1,255.66,448.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.27,390.18l-8.52,39.54,12.83,26.85a11.18,11.18,0,0,1-6.77,14.24,5.55,5.55,0,0,1-1.45.39h0c-1.5.12-5.88-1.79-6.9-2.82C309.05,456.85,293.34,442,294,435.71c.37-3.56.52-45.29.52-45.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,414.56s0,.21-.07.61-.21,1.05-.34,1.74c-.29,1.51-.76,3.69-1.1,6.4a29.54,29.54,0,0,0,.17,9.52,19.3,19.3,0,0,0,1.91,5.29,48.1,48.1,0,0,0,3.36,5.2c2.6,3.44,4.41,7.12,6.6,10.07a15.12,15.12,0,0,0,7.73,5.87,9.38,9.38,0,0,0,6.62-.54,9.5,9.5,0,0,0,2-1.42s-.1.19-.38.51a6.56,6.56,0,0,1-1.49,1.13,9.44,9.44,0,0,1-6.89.76,15.5,15.5,0,0,1-8.12-6c-2.28-3-4.07-6.63-6.65-10.05a47.82,47.82,0,0,1-3.39-5.27,19.59,19.59,0,0,1-1.93-5.47,28.85,28.85,0,0,1,0-9.69,62.86,62.86,0,0,1,1.32-6.39c.2-.75.35-1.33.47-1.72A2.27,2.27,0,0,1,308,414.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.75,432.72c-.1-.13,2.36-1.64,5.82-2.54s6.39-.84,6.38-.68-2.84.41-6.19,1.3S310.85,432.9,310.75,432.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.66,440.46c-.13-.12,1.71-1.79,4.56-3s5.41-1.36,5.42-1.19-2.39.63-5.13,1.78S316.79,440.61,316.66,440.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.78,449.46c-.15-.09,1.35-2,4-3.67s5.1-2.19,5.14-2-2.25,1-4.75,2.57S319.93,449.59,319.78,449.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.4,463.87s-.11.16-.36.43a6.11,6.11,0,0,1-1.33,1,9.57,9.57,0,0,1-6,.89,17.47,17.47,0,0,1-8-4,106.43,106.43,0,0,1-8-7.24,109.41,109.41,0,0,1-12.43-14.83c-1.42-2-2.47-3.7-3.18-4.87a12.71,12.71,0,0,1-1-1.87,14.08,14.08,0,0,1,1.25,1.74c.78,1.13,1.89,2.77,3.35,4.75a126.07,126.07,0,0,0,12.53,14.64c2.68,2.67,5.35,5.12,7.87,7.23a17.26,17.26,0,0,0,7.68,4,9.65,9.65,0,0,0,5.83-.66A13.29,13.29,0,0,0,335.4,463.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.81,436.54a11.89,11.89,0,0,1-.42-3.13,59,59,0,0,1,1-15.15,12.69,12.69,0,0,1,.83-3.06,16.71,16.71,0,0,1-.35,3.13c-.26,1.92-.59,4.57-.79,7.52s-.23,5.61-.22,7.55A17.06,17.06,0,0,1,297.81,436.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.38,256.34s7.64-.71,10.41,2.59,13.44,19.95,11.88,21.51-4.63,5.29-4.63,5.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.15,385.59c.08-.63-6.22-24.26-6.22-24.26l-.58-28.74,1.56-18.87s5.12-2.2,1-7.8l2.21-9.81-50.23-61.89s-2.57,16.62-3.84,35.86c-.29,4.5-5.61,27.34-4.1,42.07s8.53,41.64,8.83,46.38,8.66,33.64,12.89,43.42c5,11.6,12.85,35.37,12.85,35.37l31.68-7.48S252.07,386.22,252.15,385.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,257.82c1.3.58,26,39.57,28.8,49.95s-.42,36.34-1.29,41.16-13.53,65.44-14,67.1-19.73,8.89-33.1.52l-1.7-23s-2.28-24.95-1.82-32l.47-7,.22-24.37-5.6-14.4c-1.67-1.62-2.35-3.33-2-5.14l-3.56-9.13-12.38-8.91s-1.72-11.33,8.76-26.39,30.31-21,30.31-21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.24,336.88A7,7,0,0,1,198,336a36,36,0,0,1,5.17-1.56A70.73,70.73,0,0,1,221,333c1.75.1,3.45.14,5.1.34a46.41,46.41,0,0,1,4.71.75,58.12,58.12,0,0,1,7.69,2.24,50.67,50.67,0,0,1,4.95,2.09,8,8,0,0,1,1.7.95,14.63,14.63,0,0,1-1.82-.73c-1.17-.48-2.86-1.16-5-1.88a66.65,66.65,0,0,0-7.66-2.09,59.42,59.42,0,0,0-9.7-1,77.11,77.11,0,0,0-17.68,1.21,42.9,42.9,0,0,0-5.18,1.35C196.9,336.63,196.26,336.92,196.24,336.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.59,342.89a66,66,0,0,1,25.35-3.55,95,95,0,0,1,22.63,4.31l.08,3.75s-15.38-3.16-22.15-3.52c-8.42-.44-25.06,2.93-25.06,2.93Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.72,310.66a12.75,12.75,0,0,1,1.12-1.83,20.07,20.07,0,0,1,1.48-2,31.9,31.9,0,0,1,2.14-2.59,40.72,40.72,0,0,1,2.86-2.94c1.05-1.05,2.29-2,3.58-3.11a60.74,60.74,0,0,1,9.22-5.9,62.94,62.94,0,0,1,10.32-4.05c1.66-.43,3.23-.88,4.74-1.13s2.91-.5,4.2-.66,2.47-.21,3.49-.28a22.55,22.55,0,0,1,2.65-.06,14.06,14.06,0,0,1,2.25.11,16.2,16.2,0,0,1-2.24.14c-.73,0-1.61.05-2.63.17s-2.19.15-3.45.38-2.67.38-4.15.73-3,.73-4.67,1.17a65.34,65.34,0,0,0-10.17,4.05,62.84,62.84,0,0,0-9.15,5.79c-1.28,1.05-2.53,2-3.58,3s-2,1.95-2.89,2.86-1.57,1.76-2.21,2.5-1.16,1.42-1.57,2A13.22,13.22,0,0,1,282.72,310.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.37,316.05a12.75,12.75,0,0,1,1.12-1.83,20.07,20.07,0,0,1,1.48-2,32.18,32.18,0,0,1,2.15-2.59,38.7,38.7,0,0,1,2.86-2.94c1-1,2.28-2,3.57-3.11a59.61,59.61,0,0,1,9.23-5.9,62.51,62.51,0,0,1,10.31-4.05c1.66-.44,3.23-.88,4.74-1.13s2.91-.51,4.2-.66,2.47-.22,3.5-.29a24.52,24.52,0,0,1,2.64-.05,14.41,14.41,0,0,1,2.26.11,16.66,16.66,0,0,1-2.25.14c-.72,0-1.61.05-2.63.17s-2.18.15-3.45.38-2.67.38-4.15.73-3,.72-4.67,1.17a65.34,65.34,0,0,0-10.17,4A62.84,62.84,0,0,0,297,304c-1.28,1.05-2.53,2-3.58,3s-2,2-2.89,2.86-1.57,1.76-2.21,2.5a24.8,24.8,0,0,0-1.56,2A13.71,13.71,0,0,1,285.37,316.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.9 232.4 263.53 227.58 199.92 234.22 200.63 259.26 199.2 260.64 250.5 297.37 255.8 292.95 267.07 292.59 306.88 247.07 301.9 232.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.65,250.77a21,21,0,0,1-2.38.56,53.74,53.74,0,0,0-6.35,1.86,49.23,49.23,0,0,0-18,11.28,44.69,44.69,0,0,0-12.37,23.59,18.17,18.17,0,0,1-.44,2.25,2.24,2.24,0,0,1,0-.59c0-.39.06-1,.17-1.69a37.27,37.27,0,0,1,1.34-6.13A43.25,43.25,0,0,1,281.37,264a47.78,47.78,0,0,1,18.38-11.27,45.56,45.56,0,0,1,6.47-1.68c.77-.15,1.39-.21,1.8-.27A2.31,2.31,0,0,1,308.65,250.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.44,294.88a2.24,2.24,0,0,1-.39-.48l-1-1.44c-.41-.63-.94-1.4-1.61-2.25s-1.37-1.86-2.29-2.88-1.85-2.18-3-3.32-2.38-2.34-3.71-3.58a74.07,74.07,0,0,0-9.57-7.09,76.84,76.84,0,0,0-10.77-5.4c-1.74-.65-3.39-1.31-5-1.77s-3.08-.92-4.46-1.26-2.64-.59-3.74-.82-2.07-.39-2.86-.49l-1.81-.29c-.42-.08-.64-.12-.63-.15a2.82,2.82,0,0,1,.64,0l1.84.17a26.29,26.29,0,0,1,2.89.38c1.12.21,2.41.38,3.79.74s2.92.67,4.52,1.19,3.29,1.08,5.06,1.73a72.58,72.58,0,0,1,10.91,5.41,70.45,70.45,0,0,1,9.62,7.2c1.34,1.26,2.63,2.43,3.71,3.65s2.09,2.33,2.95,3.4,1.58,2.08,2.22,3a23,23,0,0,1,1.52,2.32c.36.6.65,1.1.89,1.51A1.89,1.89,0,0,1,253.44,294.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.26,300.41a14.74,14.74,0,0,1,2.06-1,22.74,22.74,0,0,1,2.5-1c1-.35,2.11-.8,3.41-1.13l2-.56c.7-.19,1.45-.32,2.22-.49,1.54-.36,3.21-.56,5-.8a58,58,0,0,1,22.86,1.92c1.68.53,3.29,1,4.73,1.62.72.3,1.44.54,2.1.85l1.87.89a35.18,35.18,0,0,1,3.14,1.68,21.51,21.51,0,0,1,2.27,1.42,17.18,17.18,0,0,1,1.83,1.33,13.6,13.6,0,0,1-2-1.12,26.23,26.23,0,0,0-2.31-1.32c-.93-.47-1.94-1.08-3.16-1.58l-1.88-.85c-.65-.29-1.37-.52-2.09-.8-1.43-.59-3-1-4.7-1.55a65.49,65.49,0,0,0-11.19-2,66.24,66.24,0,0,0-11.41.12c-1.73.23-3.4.4-4.92.74-.76.16-1.51.27-2.21.44l-2,.52c-1.29.3-2.41.72-3.41,1a25.76,25.76,0,0,0-2.53.91A15.93,15.93,0,0,1,192.26,300.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.68,309.92a15.15,15.15,0,0,1,2-.92l1.11-.46,1.36-.45c1-.31,2.08-.71,3.35-1l2-.49c.7-.15,1.43-.27,2.18-.41,1.5-.31,3.14-.45,4.85-.67a70.79,70.79,0,0,1,11.21,0,75,75,0,0,1,11.05,1.8c1.66.45,3.25.85,4.68,1.35s2.78.95,4,1.43,2.26,1,3.19,1.38a25.54,25.54,0,0,1,2.34,1.16,13.7,13.7,0,0,1,1.92,1.11,14.48,14.48,0,0,1-2-.89c-.65-.31-1.44-.68-2.39-1.06s-2-.86-3.21-1.27-2.52-.93-4-1.35-3-.85-4.66-1.28a80.25,80.25,0,0,0-10.95-1.74,75.92,75.92,0,0,0-11.09,0c-1.7.19-3.32.31-4.81.6-.74.13-1.47.23-2.16.37l-2,.44c-1.27.26-2.37.62-3.36.9l-1.36.39-1.13.41A14.17,14.17,0,0,1,191.68,309.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.91,323.7a25.83,25.83,0,0,1,3.45-2.44c2.18-1.45,5.22-3.4,8.6-5.53l6.8-4.21-.12.24c-.08-1.86-.12-3.4-.13-4.47a6.63,6.63,0,0,1,.07-1.7,6.6,6.6,0,0,1,.26,1.68c.11,1.07.24,2.61.38,4.46v.15l-.14.09-6.74,4.3c-3.38,2.13-6.47,4-8.72,5.37A27,27,0,0,1,194.91,323.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.14,384.58a8,8,0,0,1,1.17-1.29,18.63,18.63,0,0,1,1.51-1.39c.62-.51,1.3-1.14,2.14-1.71a30.22,30.22,0,0,1,2.77-1.87c1-.66,2.17-1.24,3.37-1.87a47.82,47.82,0,0,1,8.35-3.12,48.53,48.53,0,0,1,8.86-1.39c1.39,0,2.7-.11,3.93,0s2.37.13,3.41.25,2,.29,2.78.43a17.57,17.57,0,0,1,2.07.45,9.86,9.86,0,0,1,1.72.53c0,.13-2.51-.57-6.62-.95-1-.09-2.16-.18-3.37-.17s-2.51,0-3.87.1a50.78,50.78,0,0,0-8.72,1.42,49.75,49.75,0,0,0-8.24,3c-1.2.61-2.35,1.16-3.36,1.79s-1.95,1.21-2.78,1.78C209,382.87,207.25,384.68,207.14,384.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.75,391.42a8.9,8.9,0,0,1,1.15-1.2c.39-.37.87-.82,1.47-1.3s1.25-1.06,2.06-1.6a44.16,44.16,0,0,1,5.84-3.59,50.52,50.52,0,0,1,7.85-3.18,53.12,53.12,0,0,1,8.36-1.77,47.59,47.59,0,0,1,7-.31c1,0,1.89.1,2.68.16a17.65,17.65,0,0,1,2,.24,8.89,8.89,0,0,1,1.68.33c0,.13-2.44-.26-6.38-.28a53,53,0,0,0-6.89.46,50.76,50.76,0,0,0-16,4.87,49.48,49.48,0,0,0-5.84,3.43C211.56,389.86,209.85,391.52,209.75,391.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.43,352.38a11.58,11.58,0,0,1-1.87-.52c-.59-.19-1.31-.41-2.16-.63s-1.81-.53-2.9-.75a71.25,71.25,0,0,0-7.67-1.39,69.66,69.66,0,0,0-19.06.27,71,71,0,0,0-7.62,1.6c-1.08.26-2,.58-2.87.83s-1.56.49-2.14.7a11,11,0,0,1-1.85.56,11,11,0,0,1,1.75-.8c.57-.24,1.27-.53,2.11-.8s1.78-.64,2.86-.93a63.18,63.18,0,0,1,7.66-1.75,70.11,70.11,0,0,1,9.61-.85,70.86,70.86,0,0,1,9.64.58,62.47,62.47,0,0,1,7.71,1.53c1.09.26,2,.59,2.89.85s1.56.52,2.13.75A11.21,11.21,0,0,1,339.43,352.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.1,359a10,10,0,0,1-1.9-.37c-1.2-.29-3-.66-5.14-1s-4.81-.73-7.73-1a89.27,89.27,0,0,0-9.54-.2,88,88,0,0,0-9.49.9c-2.89.46-5.47,1-7.62,1.55s-3.86,1-5,1.41a9.76,9.76,0,0,1-1.86.51,11.47,11.47,0,0,1,1.77-.74,52.52,52.52,0,0,1,5-1.62,71.51,71.51,0,0,1,7.64-1.7,83.87,83.87,0,0,1,9.58-1,80.72,80.72,0,0,1,9.62.26,73.71,73.71,0,0,1,7.76,1.12c2.19.44,3.94.88,5.12,1.25A11.2,11.2,0,0,1,338.1,359Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.82,315.52c-8-6-19.68-7.07-29.29-3.81s-17.43,10.08-23.3,17.88l-1.84-5.12c5.87-7.8,14.59-15.07,24.2-18.32s21.71-2.22,29.67,3.76A28.46,28.46,0,0,1,342.82,315.52Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.82,309.07c.67,1.49,3.72,2.38,5.78,1.95,2.61-.55,6.13-2.76,8.2-3.1,12-1.93,19.89,4.92,34.33,5.26.28,0,.58.15.83,0a.67.67,0,0,0,.18-.95,2.05,2.05,0,0,0-.88-.67c-14.59-7.42-32.49-7.66-48.44-2.51"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286.32,315.66c7.29-5.1,12-13.24,20.2-17,7-3.23,15.7-2.74,22.19-6.83-17.07.63-33.56,9.43-42.79,22.82"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M291.68,420c11.76,6,26.5,5.32,37.84-1.15a3,3,0,0,0,.73-4.36,3.58,3.58,0,0,0-4.67-.68c-9.42,5.38-21.61,5.36-31.22.48a3.48,3.48,0,0,0-4.41,1.6c-.78,1.66.14,3.3,1.73,4.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,440.82q15.67-4.32,31.73-7.31a3.25,3.25,0,0,0,2.93-3.46,3.33,3.33,0,0,0-3.71-2.73q-16.88,3.15-33.4,7.69a3.08,3.08,0,0,0-1.89,4,3.51,3.51,0,0,0,4.34,1.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.79,365.19s6.93,8.23,6.24,11.88-8.95,29.7-8.95,29.7l-5.21,3.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.83,409.39c-.19,0,1.88-10.67,4.64-23.75S337.6,362,337.79,362s-1.89,10.66-4.64,23.75S328,409.42,327.83,409.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.2,404.33a3.76,3.76,0,0,1,1.33-4.36c3.83-2.9,11.32-7.93,13.29-6.16s6.61,19.79,8.37,27.05a3.82,3.82,0,0,1-2.3,4.37l-7.47,3.28a3.54,3.54,0,0,1-4.72-1.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.2,404.33a4.46,4.46,0,0,1,.39.83c.26.62.59,1.43,1,2.44.86,2.19,2.07,5.25,3.54,9,.74,1.91,1.55,4,2.41,6.23.44,1.12.88,2.28,1.34,3.47a3.14,3.14,0,0,0,2.74,2.2,3.49,3.49,0,0,0,1.93-.38l2-.89,4.16-1.84a7.88,7.88,0,0,0,2-1,3.5,3.5,0,0,0,1.13-1.73,3.64,3.64,0,0,0-.06-2.09c-.18-.74-.37-1.49-.55-2.24-1.5-6-3-11.73-4.56-16.87a36.59,36.59,0,0,0-2.73-7.05c-.52-1-2-.66-3-.34a20.43,20.43,0,0,0-3,1.35c-1.87,1-3.47,2.06-4.87,3l-1.91,1.34a5.19,5.19,0,0,0-1.4,1.29,3.8,3.8,0,0,0-.66,2.42c.06.58.18.88.15.89a2.64,2.64,0,0,1-.29-.88,3.75,3.75,0,0,1,.57-2.57,5.23,5.23,0,0,1,1.42-1.39c.57-.44,1.2-.9,1.89-1.39a50.36,50.36,0,0,1,4.85-3.1,19.68,19.68,0,0,1,3.1-1.43,6.33,6.33,0,0,1,1.85-.39,2.45,2.45,0,0,1,1,.19,1.94,1.94,0,0,1,.76.71,36.72,36.72,0,0,1,2.87,7.18c1.61,5.15,3.12,10.87,4.62,16.89.18.76.37,1.5.55,2.25a4.22,4.22,0,0,1,0,2.39,4,4,0,0,1-1.34,2,4.32,4.32,0,0,1-1.06.67L229,426l-4.16,1.82-2,.88a4.22,4.22,0,0,1-2.28.43,3.76,3.76,0,0,1-3.24-2.61L216,423q-1.26-3.37-2.33-6.26c-1.39-3.77-2.52-6.86-3.34-9.07l-.87-2.47A5,5,0,0,1,209.2,404.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.84,315.94a17.45,17.45,0,0,1-2.14-.41,55.32,55.32,0,0,0-5.86-.89,52.1,52.1,0,0,0-19.3,1.73A49.62,49.62,0,0,0,292.3,329a14.61,14.61,0,0,1-1.52,1.47s.09-.17.31-.45.54-.69,1-1.19a40.88,40.88,0,0,1,4.17-4,47.42,47.42,0,0,1,17.07-9,49.82,49.82,0,0,1,19.57-1.56,44.46,44.46,0,0,1,5.86,1.09c.69.17,1.2.35,1.55.45A2.09,2.09,0,0,1,340.84,315.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.39,323a13.83,13.83,0,0,1-2.08-.25c-.66-.11-1.48-.23-2.43-.33s-2-.27-3.21-.34a81.69,81.69,0,0,0-8.42-.31,81,81,0,0,0-20.33,2.89A83.41,83.41,0,0,0,298,327.3c-1.12.4-2.09.86-3,1.22s-1.61.7-2.21,1a13.23,13.23,0,0,1-1.9.82,12.15,12.15,0,0,1,1.77-1c.58-.32,1.3-.7,2.17-1.09s1.82-.89,2.93-1.32a71.71,71.71,0,0,1,7.95-2.79,75,75,0,0,1,20.5-2.92,72.12,72.12,0,0,1,8.48.45c1.2.1,2.28.3,3.22.44s1.76.29,2.42.44A12.17,12.17,0,0,1,342.39,323Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.27,352a10.3,10.3,0,0,1,1.62-.92,17.55,17.55,0,0,1,2-.95c.79-.34,1.67-.76,2.7-1.11a50.69,50.69,0,0,1,7.34-2.12,53.63,53.63,0,0,1,18.74-.55,52.09,52.09,0,0,1,7.47,1.68c1,.29,2,.66,2.77.95a19,19,0,0,1,2,.83,10.74,10.74,0,0,1,1.68.83c-.06.12-2.48-1-6.63-2.17a56.13,56.13,0,0,0-7.42-1.53,56.31,56.31,0,0,0-18.5.55,55.49,55.49,0,0,0-7.3,2C201.68,350.88,199.34,352.15,199.27,352Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,352.43a9.39,9.39,0,0,1-1.8.06h-4.9c-4.13,0-9.84.21-16.12.74s-11.93,1.33-16,2l-4.82.82a10.64,10.64,0,0,1-1.78.24,8.38,8.38,0,0,1,1.73-.49c1.12-.28,2.75-.63,4.78-1a158.11,158.11,0,0,1,32.22-2.73c2.07,0,3.74.11,4.9.19A10.05,10.05,0,0,1,246,352.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,225.42s27.74,7.23,58.14,6,42.31-7.14,42.31-7.14l1.8,10.22s-36.94,14.34-103.51.78C198.76,235.26,198.2,227.63,200,225.42Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.71 227.68 210.98 238.58 218.02 239.54 219.17 227.49 211.71 227.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.58 228.21 285.31 238.83 292.35 237.82 289.65 225.98 282.58 228.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.85 241.45 228.36 240.43 229.61 230.33 239.1 231.35 237.85 241.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M233.42,215.21c-9.76,5.39-23.29,11-33,16.44l-1,6.45c8.22-2.75,18.28-6.36,25.42-11.27,2-1.38,5.86-4,7.32-6S234.2,217.52,233.42,215.21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,203.52c-7.2,3.52-15.09,9.08-14.15,18.19.85,8.3,9,11.77,16.38,12.42,18.78,1.65,37.39-7.73,52.88-17.27,5-3.08.41-11-4.62-7.9-11.52,7.1-23.88,13.6-37.44,15.59-4.64.68-12.47,1.82-16.57-1.38-5.94-4.64,5.54-10,8.74-11.61l-.12-9.8a33.84,33.84,0,0,0-5.1,1.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,203.52a9.67,9.67,0,0,1,1.25-.58,35.6,35.6,0,0,1,3.83-1.26l.1,0v.11c0,2.45.11,5.75.18,9.8v.08l-.08,0a47.78,47.78,0,0,0-6.42,3.64,12.93,12.93,0,0,0-3,2.8,4.11,4.11,0,0,0-.83,1.93,2.77,2.77,0,0,0,.63,2,7.64,7.64,0,0,0,3.95,2.4,19.25,19.25,0,0,0,5,.65,64.43,64.43,0,0,0,10.84-1.18,85.27,85.27,0,0,0,23-8.36c3.87-2,7.74-4.25,11.63-6.63a5.23,5.23,0,0,1,.78-.42,2.78,2.78,0,0,1,.84-.33,4,4,0,0,1,1.81-.12,4.67,4.67,0,0,1,3,2,5.32,5.32,0,0,1,1,3.46,4.45,4.45,0,0,1-1.72,3.2,153.8,153.8,0,0,1-18.44,10.17c-3.1,1.4-6.18,2.71-9.28,3.75-1.54.57-3.1,1-4.63,1.47s-3.08.84-4.61,1.13a55.23,55.23,0,0,1-17.68,1,24.51,24.51,0,0,1-7.74-2.22,14.48,14.48,0,0,1-5.72-4.72,12.17,12.17,0,0,1-2-6.42,13.22,13.22,0,0,1,1.11-5.91,18.9,18.9,0,0,1,6.18-7.29,35.41,35.41,0,0,1,5.16-3.21c.62-.33,1.1-.55,1.42-.71l.49-.22s-.15.1-.47.27-.78.4-1.39.75a38.12,38.12,0,0,0-5.09,3.28,18.88,18.88,0,0,0-6,7.25,13.1,13.1,0,0,0-1,5.78,11.83,11.83,0,0,0,2,6.22,14.21,14.21,0,0,0,5.59,4.57,24.24,24.24,0,0,0,7.62,2.15,55,55,0,0,0,17.53-1.06c12.17-2.61,24.67-8.81,36.73-16.46a3.9,3.9,0,0,0,1.53-2.82,4.76,4.76,0,0,0-.92-3.13,4.2,4.2,0,0,0-2.66-1.74,3.61,3.61,0,0,0-1.6.1,2.68,2.68,0,0,0-.75.3,5.27,5.27,0,0,0-.73.4c-3.9,2.38-7.78,4.64-11.67,6.63a84.86,84.86,0,0,1-23.15,8.36,63.2,63.2,0,0,1-10.94,1.15,19.42,19.42,0,0,1-5.09-.68,8,8,0,0,1-4.13-2.55,3.23,3.23,0,0,1-.69-2.27,4.62,4.62,0,0,1,.9-2.1,13.59,13.59,0,0,1,3.13-2.87,47.55,47.55,0,0,1,6.49-3.61l-.07.12c0-4.05-.05-7.35-.07-9.8l.1.08c-1.71.45-3,.87-3.84,1.18-.43.16-.74.29-1,.38A1.27,1.27,0,0,1,179.9,203.52Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.9fcb265f6f9843d7971148537263c95b.svg";
export { ForwardRef as ReactComponent };